<app-alert></app-alert>
<section class="panel panel-default">
    <div class="card-header">
        <title>SH-2 Register of Renewed and Duplicate Share Certificates</title>
         <span class="cat__core__title">
               <strong id="pageTitle">SH-2 Register of Renewed and Duplicate Share Certificates</strong>
         </span> 
         <span style="float: right">
                <!-- <a routerLink="/sh2-list"> -->
                    <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
                        <i class=" fa fa-chevron-circle-left"></i>
                        Back
                    </button>
                <!-- </a> -->
            </span>
            <!-- <span style="float:right">
                <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictTabflag">
                  <span>
                    <i class="fa fa-save"></i>Generate Output </span>
                </button>
        </span> -->
              <meta charset="utf-8">    
    </div>
  
    
    <form [formGroup] ="sh2Form" (document:click)="a.close();b.close()">
        <div class="modal-body">
            <div class="row">
                
               

                   <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12"><br>
                    <label class="form-control-label" for="l0">Original Share Certificate Number<span
                        _ngcontent-c2="" style="color: red;">*</span></label>
                 
                      <select [formControl]="sh2Form.controls['ogShareCertiNumber']" class="form-control" (change)="getsh2FormDetails($event, sh2Form.controls.ogShareCertiNumber.value)"  style="padding: 6px;"> 
                            <option value="">Select any one</option>  
                            <option *ngFor="let item of certificateNoList; let i = index;" [attr.data-mgt1id]="item.MGT1_id"  value="{{item.certificateNo}}">  
                                {{item.certificateNo}}
                            </option> 
                      </select>
                      <div *ngIf="sh2Form.controls['ogShareCertiNumber'].hasError('required') && sh2Form.controls['ogShareCertiNumber'].touched" class="form-control-error-custom">
                        Original Share Certificate Number is required
                      </div>
                      <div *ngIf="(sh2Form.controls['ogShareCertiNumber'].hasError('pattern') || sh2Form.controls['ogShareCertiNumber'].hasError('maxlength')) && sh2Form.controls['ogShareCertiNumber'].touched"
                      class="form-control-error-custom">
                      Original Share Certificate Number is invalid
                    </div>
                     
                   </div>

                
                <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label" for="l0">Name of the person(s) to whom Renewed / Duplicate share certificate is issued</label>
                     
                          <!-- <select [formControl]="sh2Form.controls['namePersonRenewedDuplicateCertiisIssued']" class="form-control" style="padding: 6px;"> 
                                <option value="">Select any one</option>  
                                <option *ngFor="let nameOfMember of nameOfMemberList; let i = index;" value="{{nameOfMember}}">  
                                    {{nameOfMember}}
                                </option> 
                          </select> -->
                          
                            <div class="form-group">
                              <input [formControl]="sh2Form.controls['namePersonRenewedDuplicateCertiisIssued']" class="form-control" readonly>
                            </div>
                         
                          <div *ngIf="(sh2Form.controls['namePersonRenewedDuplicateCertiisIssued'].hasError('pattern') || sh2Form.controls['namePersonRenewedDuplicateCertiisIssued'].hasError('maxlength')) && sh2Form.controls['namePersonRenewedDuplicateCertiisIssued'].touched"
                          class="form-control-error-custom">
                          Name of the person(s) to whom Renewed / Duplicate share certificate is issued is invalid
                         </div>
                         
                </div>
                  

                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Date of approval of issue of Renewed/ Duplicate share certificate</label>
                    <div class="form-group">
                        <div class="input-group" (click)="$event.stopPropagation()">
                          <input class="form-control"  [formControl]="sh2Form.controls['doaIssueofRenewedDuplicateShareCerti']" [(ngModel)]="doaIssueofRenewedDuplicateShareCertiModel"
                              style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                              name="doaIssueofRenewedDuplicateShareCerti" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();">
                          <button class="input-group-addon" (click)="a.toggle();"
                              type="button">
                              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                          </button>
                        </div>
                        <div *ngIf="(sh2Form.controls['doaIssueofRenewedDuplicateShareCerti'].hasError('pattern') || sh2Form.controls['doaIssueofRenewedDuplicateShareCerti'].hasError('maxlength')) && sh2Form.controls['doaIssueofRenewedDuplicateShareCerti'].touched"
                        class="form-control-error-custom">
                        Date of approval of issue of Renewed/ Duplicate share certificate is invalid
                    </div>
                    </div>
                </div>
            </div>                         

            <div class="row">

                 <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label" for="l0">Class of Shares</label>
                 
                      <!-- <select [formControl]="sh2Form.controls['classofShares']" class="form-control" style="padding: 6px;"> 
                            <option value="">Select any one</option>  
                            <option *ngFor="let shares of classofSharesList; let i = index;" value="{{shares.selectTypes}}">  
                                {{shares.selectTypes}}
                            </option> 
                      </select> -->
                      <div class="form-group">
                        <input [formControl]="sh2Form.controls['classofShares']" class="form-control" readonly>
                      </div>
                      
                      <div *ngIf="(sh2Form.controls['classofShares'].hasError('pattern') || sh2Form.controls['classofShares'].hasError('maxlength')) && sh2Form.controls['classofShares'].touched"
                      class="form-control-error-custom">
                      Class of Shares is invalid
                       </div>
                     
                   </div>



                <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label" for="l0">Total number of shares in the Original Share Certificate</label>
                     
                          <!-- <select [formControl]="sh2Form.controls['totalSharesinOGshareCerti']" class="form-control" style="padding: 6px;"> 
                                <option value="">Select any one</option>  
                                <option *ngFor="let noOfSharesAlloted of noOfSharesAllotedList; let i = index;" value="{{noOfSharesAlloted}}">  
                                    {{noOfSharesAlloted}}
                                </option> 
                          </select> -->
                          <div class="form-group">
                            <input [formControl]="sh2Form.controls['totalSharesinOGshareCerti']" class="form-control" readonly>
                          </div>

                          <div *ngIf="(sh2Form.controls['totalSharesinOGshareCerti'].hasError('pattern') || sh2Form.controls['totalSharesinOGshareCerti'].hasError('maxlength')) && sh2Form.controls['totalSharesinOGshareCerti'].touched"
                              class="form-control-error-custom">
                              Total number of shares in the Original Share Certificate is invalid
                    </div>
                </div>

                

             <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                <label class="form-control-label" for="l0">Folio No</label>
             
                  <!-- <select [formControl]="sh2Form.controls['folioNo']" class="form-control" style="padding: 6px;"> 
                        <option value="">Select any one</option>  
                        <option *ngFor="let folio of folioNoDematAcNoList; let i = index;" value="{{folio.folioNoDematAcNo}}">  
                            {{folio.folioNoDematAcNo}}
                        </option> 
                  </select> -->
                  <div class="form-group">
                    <input [formControl]="sh2Form.controls['folioNo']" class="form-control" readonly>
                  </div>
                  
                  
                  <div *ngIf="(sh2Form.controls['folioNo'].hasError('pattern') || sh2Form.controls['folioNo'].hasError('maxlength')) && sh2Form.controls['folioNo'].touched"
                  class="form-control-error-custom">
                  Folio No is invalid
                   </div>
                 
               </div>
               
    

         </div>



            <div class="row">  
             
            <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
              <label class="form-control-label" for="l0">Date of issue of original share certificate</label>
            
              <!-- <select [formControl]="sh2Form.controls['doiOGshareCerti']" class="form-control" style="padding: 6px;"> 
                                        <option value="">Select any one</option>  
                                        <option *ngFor="let dateOfIssue of dateOfIssueList; let i = index;" value="{{dateOfIssue}}">  
                                            {{dateOfIssue | date: 'dd-MM-yyyy'}}
                                        </option> 
                                  </select> -->
              <!-- <div class="form-group">
                <input [formControl]="sh2Form.controls['doiOGshareCerti']" class="form-control" readonly>
              </div>
            
              <div
                *ngIf="(sh2Form.controls['doiOGshareCerti'].hasError('pattern') || sh2Form.controls['doiOGshareCerti'].hasError('maxlength')) && sh2Form.controls['doiOGshareCerti'].touched"
                class="form-control-error-custom">
                Date of issue of original share certificate is invalid
              </div> -->


              <div class="form-group">
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input class="form-control"  [formControl]="sh2Form.controls['doiOGshareCerti']" [(ngModel)]="doiOGshareCerti"
                      style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                      name="doiOGshareCerti" ngbDatepicker #b="ngbDatepicker" disabled>
                  <button class="input-group-addon" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;" disabled></span>
                  </button>
                </div>
                <div
                  *ngIf="(sh2Form.controls['doiOGshareCerti'].hasError('pattern') || sh2Form.controls['doiOGshareCerti'].hasError('maxlength')) && sh2Form.controls['doiOGshareCerti'].touched"
                  class="form-control-error-custom">
                  Date of issue of original share certificate is invalid
                </div>
               </div> 
            </div>

                
                <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label" for="l0">Distinctive No. of shares "From"</label>
                 
                      <!-- <select [formControl]="sh2Form.controls['disctinctiveNoofSharesFrom']" class="form-control" style="padding: 6px;"> 
                            <option value="">Select any one</option>  
                            <option *ngFor="let distinctiveFrom of distinctiveFromList; let i = index;" value="{{distinctiveFrom}}">  
                                {{distinctiveFrom}}
                            </option> 
                      </select> -->
                      <div class="form-group">
                        <input [formControl]="sh2Form.controls['disctinctiveNoofSharesFrom']" class="form-control" readonly>
                      </div>
                      <div *ngIf="(sh2Form.controls['disctinctiveNoofSharesFrom'].hasError('pattern') || sh2Form.controls['disctinctiveNoofSharesFrom'].hasError('maxlength')) && sh2Form.controls['disctinctiveNoofSharesFrom'].touched"
                    class="form-control-error-custom">
                    Distinctive No. of shares From is invalid
                      </div>
                   </div>

              
            <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                <label class="form-control-label" for="l0">Distinctive No. of shares "To"</label>
             
                  <!-- <select [formControl]="sh2Form.controls['disctinctiveNoofSharesTo']" class="form-control" style="padding: 6px;"> 
                        <option value="">Select any one</option>  
                        <option *ngFor="let distinctiveTo of distinctiveToList; let i = index;" value="{{distinctiveTo}}">  
                            {{distinctiveTo}}
                        </option> 
                  </select> -->
                  <div class="form-group">
                    <input [formControl]="sh2Form.controls['disctinctiveNoofSharesTo']" class="form-control" readonly>
                  </div>

                  <div *ngIf="(sh2Form.controls['disctinctiveNoofSharesTo'].hasError('pattern') || sh2Form.controls['disctinctiveNoofSharesTo'].hasError('maxlength')) && sh2Form.controls['disctinctiveNoofSharesTo'].touched"
                     class="form-control-error-custom">
                     Distinctive No. of shares To is invalid
                  </div>
                  
               </div>

               
            </div>
                                    
            <div class="row">
                
                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                        <label class="form-control-label">Date of issue of Renewed/ Duplicate Share Certificate</label>
                        <div class="form-group">
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input class="form-control"  [formControl]="sh2Form.controls['doiRenewedDuplicateShareCerti']" [(ngModel)]="doiRenewedDuplicateShareCertiModel"
                                  style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                  name="doiRenewedDuplicateShareCerti" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle();">
                              <button class="input-group-addon" (click)="b.toggle();"
                                  type="button">
                                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                            <div *ngIf="(sh2Form.controls['doiRenewedDuplicateShareCerti'].hasError('pattern') || sh2Form.controls['doiRenewedDuplicateShareCerti'].hasError('maxlength')) && sh2Form.controls['doiRenewedDuplicateShareCerti'].touched"
                            class="form-control-error-custom">
                            Date of issue of Renewed/ Duplicate Share Certificate is invalid
                        </div>
                        </div>
                    </div>
               

                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                     <label class="form-control-label">Reasons for issue of Renewed/ Duplicate Share Certificate</label>
                                    <textarea class="form-control" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="sh2Form.controls['reasonForIssueRenewedDuplicateShareCerti']"
                                        maxlength="250"></textarea>
                                    <div *ngIf="(sh2Form.controls['reasonForIssueRenewedDuplicateShareCerti'].hasError('pattern') || sh2Form.controls['reasonForIssueRenewedDuplicateShareCerti'].hasError('maxlength')) && sh2Form.controls['reasonForIssueRenewedDuplicateShareCerti'].touched"
                                        class="form-control-error-custom">
                                        Reasons for issue of Renewed/ Duplicate Share Certificate is invalid
                                     </div>
                 </div>

                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                        <label class="form-control-label">Number of the Renewed share certificate, if applicable</label>
                        <div class="form-group">
                        <input type="text" class="form-control" [formControl]="sh2Form.controls['numberRenewedShareCertiifApplicable']" (keydown)="noBlankSpaceAtStart($event)">
                        <div *ngIf="(sh2Form.controls['numberRenewedShareCertiifApplicable'].hasError('pattern') || sh2Form.controls['numberRenewedShareCertiifApplicable'].hasError('maxlength')) && sh2Form.controls['numberRenewedShareCertiifApplicable'].touched"
                         class="form-control-error-custom">
                         Number of the Renewed share certificate, if applicable is invalid
                      </div>
                    </div>
                </div>

               
            </div>

            <div class="row">

                        <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Total Number of Shares in the Renewed Duplicate Share Certificate</label>
                                <div class="form-group">
                                <input type="number" class="form-control" [formControl]="sh2Form.controls['totalNoSharesRenewedDupliateShareCerti']" (keydown)="noBlankSpaceAtStart($event)">
                                <div *ngIf="(sh2Form.controls['totalNoSharesRenewedDupliateShareCerti'].hasError('pattern') || sh2Form.controls['totalNoSharesRenewedDupliateShareCerti'].hasError('maxlength')) && sh2Form.controls['totalNoSharesRenewedDupliateShareCerti'].touched"
                                 class="form-control-error-custom">
                                 Total Number of Shares in the Renewed Duplicate Share Certificate is invalid
                              </div>
                            </div>
                        </div>


                 <div class="col-md-4 col-sm-6 col-xs-12"><br>
                    <label class="form-control-label">Whether Renewed / Duplicate share certificate is issued </label>
                    <div class="form-group">
                        <input type="text" class="form-control" [formControl]="sh2Form.controls['whetherRenewedDuplicateShareCertiisIssued']" (keydown)="noBlankSpaceAtStart($event)">
                        <div *ngIf="(sh2Form.controls['whetherRenewedDuplicateShareCertiisIssued'].hasError('pattern') || sh2Form.controls['whetherRenewedDuplicateShareCertiisIssued'].hasError('maxlength')) && sh2Form.controls['whetherRenewedDuplicateShareCertiisIssued'].touched"
                                 class="form-control-error-custom">
                                 Whether Renewed / Duplicate share certificate is issued is invalid
                         </div>
                 </div>
                </div>

                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                        <label class="form-control-label">Reference to entry in Register of Members </label>
                        <div class="form-group">
                            <input type="text" class="form-control" [formControl]="sh2Form.controls['referenceEntryRegiterofMembers']" (keydown)="noBlankSpaceAtStart($event)">
                            <div *ngIf="(sh2Form.controls['referenceEntryRegiterofMembers'].hasError('pattern') || sh2Form.controls['referenceEntryRegiterofMembers'].hasError('maxlength')) && sh2Form.controls['referenceEntryRegiterofMembers'].touched"
                                     class="form-control-error-custom">
                                     Reference to entry in Register of Members is invalid
                             </div>
                     </div>
                    </div>
                                        
            </div>
        
    
    </div> 
   <div class="card-footer" align="right">
        <div class="form-group" *ngIf="!restrictTabflag">
          <button class="btn-sm btn btn-primary" (click)="showFormEntry()" type="button" [disabled]="!(sh2Form.valid) || disabledOnClick">
                <span>
                        <i class="fa fa-save"></i>&nbsp;Save </span>
          </button>
        </div>
        <div class="form-group" *ngIf="restrictTabflag">
          <button class="btn btn-sm btn-primary" (click)="updateSh2()" type="button" [disabled]="!(sh2Form.valid) || disabledOnClick">
            <span>
              <i class="fa fa-save"></i>&nbsp;Update </span>
          </button>
        </div>
      </div>
</form>  
</section>
